import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { fieldContextConfigPageResource } from '@jira/router-resources__forge-field-context-config/src/fieldContextConfigPageResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { forgeCustomFieldTypeResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { forgeFieldContextualConfigurationRoute } from '@jira/router-routes__forge-routes/src/forgeFieldContextualConfigurationRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ForgeFieldContextConfigPage, {
	LazyForgeFieldContextConfigPage,
} from './ui/field-context-config/index.tsx';

export const forgeFieldContextualConfigurationRouteEntry: Route = createEntry(
	forgeFieldContextualConfigurationRoute,
	() => ({
		// eslint-disable-next-line no-restricted-syntax
		component: ForgeFieldContextConfigPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			forgeCustomFieldTypeResource,
			fieldContextConfigPageResource,
			navigationSidebarGlobalResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyForgeFieldContextConfigPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
